export default "__VITE_ASSET__B8hw5QH$__"